'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var generated = require('./generated.js');

var LomaClientContext = /*#__PURE__*/React.createContext(undefined);
var LomaClientProvider = function LomaClientProvider(_ref) {
  var children = _ref.children,
    client = _ref.client;
  return /*#__PURE__*/React.createElement(LomaClientContext.Provider, {
    value: client
  }, children);
};
var useLomaClient = function useLomaClient() {
  return React.useContext(LomaClientContext);
};

exports.DriverLocationsDocument = generated.DriverLocationsDocument;
exports.GetDecodedParamsDocument = generated.GetDecodedParamsDocument;
exports.GetMarketingAssetDocument = generated.GetMarketingAssetDocument;
exports.GetNotificationPreferencesAndLevelDocument = generated.GetNotificationPreferencesAndLevelDocument;
exports.MaptilerDocument = generated.MaptilerDocument;
exports.UnsubscribeNotificationPreferencesAllLevelsDocument = generated.UnsubscribeNotificationPreferencesAllLevelsDocument;
exports.UpdateNotificationPreferencesAllLevelsDocument = generated.UpdateNotificationPreferencesAllLevelsDocument;
exports.useDriverLocationsLazyQuery = generated.useDriverLocationsLazyQuery;
exports.useDriverLocationsQuery = generated.useDriverLocationsQuery;
exports.useGetDecodedParamsLazyQuery = generated.useGetDecodedParamsLazyQuery;
exports.useGetDecodedParamsQuery = generated.useGetDecodedParamsQuery;
exports.useGetMarketingAssetLazyQuery = generated.useGetMarketingAssetLazyQuery;
exports.useGetMarketingAssetQuery = generated.useGetMarketingAssetQuery;
exports.useGetNotificationPreferencesAndLevelLazyQuery = generated.useGetNotificationPreferencesAndLevelLazyQuery;
exports.useGetNotificationPreferencesAndLevelQuery = generated.useGetNotificationPreferencesAndLevelQuery;
exports.useMaptilerLazyQuery = generated.useMaptilerLazyQuery;
exports.useMaptilerQuery = generated.useMaptilerQuery;
exports.useUnsubscribeNotificationPreferencesAllLevelsMutation = generated.useUnsubscribeNotificationPreferencesAllLevelsMutation;
exports.useUpdateNotificationPreferencesAllLevelsMutation = generated.useUpdateNotificationPreferencesAllLevelsMutation;
exports.LomaClientProvider = LomaClientProvider;
exports.useLomaClient = useLomaClient;
